import type { BeforeRequestHook } from "ky";

import { showLoader } from "@/redux/actions/loader";
import store from "@/redux/store";

import type { ApiContext } from "../../types";

const dispatch = store.dispatch;

export const loaderStartHook: BeforeRequestHook = ({ options }) => {
  const context = options.context as ApiContext | undefined;

  if (context?.showLoader !== false) {
    dispatch(showLoader());
  }
};
